import { Spinner, Text, VStack } from '@gluestack-ui/themed';

export interface LoadingStateProps {
  readonly label?: string;
  readonly testID?: string;
}

/**
 * Busy indicator for a region that is still loading.
 *
 * `role="status"` with `aria-live="polite"` announces the wait without stealing focus,
 * and the visible label means the spinner is not the only signal.
 */
export function LoadingState({ label = 'Loading…', testID }: LoadingStateProps): React.JSX.Element {
  return (
    <VStack
      role="status"
      aria-live="polite"
      alignItems="center"
      justifyContent="center"
      py="$10"
      space="sm"
      testID={testID}
    >
      <Spinner size="small" color="$primary500" accessibilityLabel={label} />
      <Text size="sm" color="$textLight600" $dark-color="$textDark400">
        {label}
      </Text>
    </VStack>
  );
}
